import { createContext } from 'react'
import type { RefetchOptions } from '@tanstack/react-query'

import type { BrandingSettings } from './branding-core'

export interface BrandingContextValue {
  isFetching: boolean
  refresh: (options?: RefetchOptions) => Promise<unknown>
  settings: BrandingSettings
}

export const BrandingContext = createContext<BrandingContextValue | null>(null)
